import { createContext } from 'react';

const PortfolioContext = createContext();

export default PortfolioContext;